var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "validation", staticClass: "analise", attrs: { tag: "div" } },
    [
      _vm.despacho !== null
        ? _c(
            "div",
            { staticClass: "analise" },
            [
              _vm.despacho.processo !== null
                ? _c(
                    "app-analise-header",
                    {
                      attrs: {
                        "id-processo": _vm.despacho.processo.id,
                        "numero-processo": _vm.isBahia
                          ? ""
                          : _vm.despacho.processo.numeroProcesso,
                        statusProcesso: _vm.despacho.processo.status,
                        "titulo-analise": _vm.tipoEmissao,
                        tipo:
                          typeof _vm.despacho.processo.tipo === "object"
                            ? _vm.despacho.processo.tipo.codigo
                            : _vm.despacho.processo.tipo,
                        numeroProtocolo: _vm.despacho.processo.numeroProtocolo,
                        "show-separate": true,
                        "show-messages": true,
                        opcoesHeader: true,
                        btnSolicitarInformacao: true,
                        btnSolicitarRetificacao: !_vm.isRetificacaoTitulo,
                        btnNotificarInteressado: !_vm.isRetificacaoTitulo,
                        idDespacho: _vm.despacho.id,
                        isEmissaoCertidao: _vm.isEmissaoCertidao
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "separate" },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass: "card-collapse",
                              attrs: { shadow: "hover" }
                            },
                            [
                              _c("app-despachos", {
                                attrs: {
                                  idProcesso: _vm.idProcesso,
                                  data: _vm.dadosCadastro
                                },
                                on: { getDownload: _vm.getDownload }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "analise" },
                        [
                          _c(
                            "el-steps",
                            {
                              staticClass: "extra-margin-top-bottom",
                              attrs: {
                                active: _vm.active,
                                "finish-status": "success",
                                simple: "simple"
                              }
                            },
                            [
                              _c("el-step", {
                                attrs: { title: "Informar dados" }
                              }),
                              _vm.isMaranhao
                                ? _c("el-step", {
                                    attrs: { title: "Edição de Título" }
                                  })
                                : _vm._e(),
                              !_vm.isCertidao
                                ? _c("el-step", {
                                    attrs: { title: "Confirmar dados" }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm.active === 0
                            ? _c(
                                "div",
                                [
                                  ((_vm.isTitulo &&
                                    !_vm.isReurb &&
                                    !_vm.isCertidaoOrTitulo &&
                                    !_vm.isNovaPortaria) ||
                                    _vm.isCertidaoOrTitulo) &&
                                  _vm.acaoParaEmissao
                                    ? _c("app-radios-tramitacao", {
                                        attrs: {
                                          radios: _vm.acaoParaEmissao,
                                          isDecisao: true,
                                          radioInicial: _vm.action
                                        },
                                        on: {
                                          changeRadio: _vm.changeRadioDespacho
                                        }
                                      })
                                    : _vm._e(),
                                  _vm.showTitulo &&
                                  !_vm.isRevisao &&
                                  !_vm.isRetorno
                                    ? _c("app-cadastra-titulo-certidao", {
                                        ref: "formulario",
                                        attrs: { despacho: _vm.despacho }
                                      })
                                    : _vm._e(),
                                  _vm.isRevisao || _vm.isRetorno
                                    ? _c(
                                        "div",
                                        [
                                          _c("validation-provider", {
                                            attrs: { rules: "required" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var errors = ref.errors
                                                    return [
                                                      _c("app-label", {
                                                        staticClass:
                                                          "input-text-editor",
                                                        attrs: {
                                                          label: "Despacho"
                                                        }
                                                      }),
                                                      _c("app-editor-texto", {
                                                        ref: "editorTexto",
                                                        staticClass: "input",
                                                        class: {
                                                          erro: errors.length
                                                        },
                                                        on: {
                                                          onTextChange:
                                                            _vm.onTextChange
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.despacho
                                                              .textoDespacho,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.despacho,
                                                              "textoDespacho",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "despacho.textoDespacho"
                                                        }
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "help erro"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              2877039618
                                            )
                                          }),
                                          _c("app-anexo", {
                                            attrs: {
                                              id: "upload-anexo-despacho",
                                              files: this.filtrarDocumentosSemAssinaturaSimbolicaMa(),
                                              tipoExibir: "ANEXO_ANALISE"
                                            },
                                            on: {
                                              uploadFile: _vm.uploadFile,
                                              removeFile: _vm.removeFile,
                                              downloadDocumentoCadastro:
                                                _vm.downloadDocumentoCadastro
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.isArquivamentoIndeferimento &&
                                  !_vm.isAmapa &&
                                  !_vm.isReurbIndividual &&
                                  !_vm.isPara
                                    ? _c(
                                        "el-card",
                                        [
                                          _c("app-label", {
                                            attrs: {
                                              label:
                                                "Inclua a Carta de Notificação ao Interessado",
                                              required:
                                                _vm.isValidateCarta !== ""
                                            }
                                          }),
                                          _c("validation-provider", {
                                            attrs: {
                                              rules: _vm.isValidateCarta
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var errors = ref.errors
                                                    return [
                                                      _c("app-anexo", {
                                                        attrs: {
                                                          id:
                                                            "upload-carta-notificacao",
                                                          files: _vm.cartas,
                                                          showAnexar: true,
                                                          errors: errors,
                                                          tiposArquivosPermitidos:
                                                            _vm.tiposArquivosPermitidosMapas,
                                                          showUpload:
                                                            _vm.cartas
                                                              .length === 0
                                                        },
                                                        on: {
                                                          uploadFile:
                                                            _vm.uploadCartaNotificacao,
                                                          removeFile:
                                                            _vm.removeCartaNotificacao,
                                                          downloadDocumentoCadastro:
                                                            _vm.getDownload
                                                        },
                                                        model: {
                                                          value: _vm.cartas,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.cartas = $$v
                                                          },
                                                          expression: "cartas"
                                                        }
                                                      })
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              87136372
                                            )
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm.active === (_vm.isMaranhao ? 2 : 1) &&
                              !_vm.isRevisao &&
                              !_vm.isRetorno
                            ? _c(
                                "div",
                                { staticClass: "margin" },
                                [
                                  _vm.bytes
                                    ? _c("app-pdf-viewer", {
                                        attrs: { bytes: _vm.bytes }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.active === (_vm.isMaranhao ? 2 : 1) &&
                          (_vm.isRevisao || _vm.isRetorno)
                            ? _c(
                                "div",
                                [
                                  _c("validation-provider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-label", {
                                                staticClass:
                                                  "input-text-editor",
                                                attrs: { label: "Despacho" }
                                              }),
                                              _c("app-editor-texto", {
                                                ref: "editorTexto",
                                                staticClass: "input",
                                                class: { erro: errors.length },
                                                on: {
                                                  onTextChange: _vm.onTextChange
                                                },
                                                model: {
                                                  value:
                                                    _vm.despacho.textoDespacho,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.despacho,
                                                      "textoDespacho",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "despacho.textoDespacho"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2877039618
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm.active === 1 &&
                              _vm.isMaranhao &&
                              !_vm.isRevisao &&
                              !_vm.isRetorno
                            ? _c(
                                "div",
                                [
                                  _c("validation-provider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("field-app-text-area", {
                                                attrs: {
                                                  formOptions: _vm.formOptions,
                                                  model: _vm.modelTexto,
                                                  schema: _vm.schema
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3657969912
                                    )
                                  }),
                                  !_vm.isRetificacaoTitulo
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "labelAssinatura" },
                                            [_vm._v("Assinaturas: ")]
                                          ),
                                          _c("app-anexo", {
                                            attrs: {
                                              files: _vm.imagensAssinaturas,
                                              id: "upload-assinaturas",
                                              tipoExibir: "ANEXO_ANALISE",
                                              fileType: ["png", "jpg", "jpeg"]
                                            },
                                            on: {
                                              uploadFile: _vm.uploadAssinatura,
                                              downloadDocumentoCadastro:
                                                _vm.downloadDocumentoCadastro,
                                              removeFile: _vm.removeAssinatura
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.active === _vm.getTelaFinal ||
                          _vm.isRevisao ||
                          (_vm.isRetorno && _vm.isMaranhao)
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "validation-observer",
                                    {
                                      ref: "validationTitulo",
                                      staticClass: "flex-around",
                                      attrs: { tag: "div" }
                                    },
                                    [
                                      _c("app-radios-tramitacao", {
                                        attrs: {
                                          radios: _vm.getAcoes,
                                          isDecisao: _vm.isDecisao,
                                          radioInicial: _vm.despacho.acao
                                        },
                                        on: { changeRadio: _vm.changeRadio }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("app-buttons-cadastro", {
                            attrs: {
                              isPrimeiroPasso: _vm.active === 0,
                              isUltimoPasso:
                                (!_vm.isMaranhao
                                  ? _vm.active === 1
                                  : [2].includes(_vm.active)) ||
                                _vm.isRevisao ||
                                _vm.isRetorno,
                              showButtonSalvar:
                                (!_vm.isMaranhao
                                  ? _vm.active === 0
                                  : [0, 1].includes(_vm.active)) &&
                                !_vm.isRevisao &&
                                !_vm.isRetorno,
                              showButtonDownload: !_vm.isMaranhao
                                ? _vm.active === 1
                                : [2].includes(_vm.active),
                              showButtonCancelar: !_vm.isMaranhao
                                ? _vm.active === 0
                                : [0, 1].includes(_vm.active),
                              showButtonFinalizar:
                                (!_vm.isMaranhao
                                  ? _vm.active === 1
                                  : [2].includes(_vm.active)) ||
                                _vm.isRevisao ||
                                _vm.isRetorno,
                              showButtonProximo:
                                (!_vm.isMaranhao
                                  ? _vm.active === 0
                                  : [0, 1].includes(_vm.active)) &&
                                !_vm.isRevisao &&
                                !_vm.isCertidao &&
                                !_vm.isRetorno
                            },
                            on: {
                              proximo: _vm.proximo,
                              salvar: _vm.salvarTituloCertidao,
                              voltar: _vm.voltar,
                              finalizar: _vm.finalizar,
                              download: _vm.downloadPdf,
                              cancelar: _vm.cancelar
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6536be58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6536be58","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/EmissaoTituloCertidao.vue
// module id = null
// module chunks = 